import classNames from "classnames/bind";

import type { LabelProps } from "../../props/input-props";
import styles from "./labels.module.scss";
const cx = classNames.bind(styles);

type Props = Omit<LabelProps, "htmlFor">;

export function Legend({
  label,
  className,
  description,
  disabled,
  required
}: Props) {
  return (
    <legend className={cx("design-label", className, { disabled })}>
      <span>
        {label}
        {required && <span className={cx({ required })}> *</span>}
      </span>
      {description && (
        <span className={cx("design-label-description")}>{description}</span>
      )}
    </legend>
  );
}
